import React, { useState, useEffect } from "react";
import { errorHandler } from "../ErrorHandler";
import PingDialog from "../modals/PingDialog";

const initialForm = {
  userName: "",
  password: "",
};

const FormLogin = ({
  loginCall,
  pingStatus,
  dialogPingVisible,
  setDialogPingVisible,
  newUserPassword,
}) => {
  const [form, setForm] = useState(initialForm);
  const [svcConnected, setSvcConnected] = useState(false);

  useEffect(() => {
    if (newUserPassword.password !== "") {
      setForm({
        ...form,
        password: newUserPassword.password,
        userName: newUserPassword.user,
      });
    }
  }, [newUserPassword]);

  const handleChange = (e) => {
    let value = e.target.value;

    if (e.target.name === "userName") {
      value = e.target.value.toUpperCase();
    }

    setForm({
      ...form,
      [e.target.name]: value,
    });
  };

  //Mensaje de error si faltan datos en el Login
  const handleSubmit = () => {
    if (!form.userName || !form.password) {
      errorHandler("Incomplete data");
      return;
    }
    loginCall(form);
    setForm(initialForm);
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleSubmit();
    }
  };

  //This useEffect runs when svcConnected change and it's true, not letting the user to continue
  useEffect(() => {
    if (pingStatus) {
      setSvcConnected(true);
    } else {
      setSvcConnected(false);
    }
  }, [pingStatus]);

  return (
    <section className="vh-100">
      <div
        className="vh-100"
        style={{
          backgroundImage: "url('../images/LoginOroManager.jpg')",
          backgroundRepeat: "no-repeat, repeat",
          backgroundSize: "100%",
        }}
        onKeyDown={handleKeyPress}
        tabIndex="0"
      >
        <div className="d-flex align-items-center h-100">
          <div
            className="col-md-7 col-lg-5 col-xl-3 offset-xl-1"
            style={{ margin: "0 auto" }}
          >
            <div
              className="card"
              style={{
                backgroundColor: "rgba(0, 0, 0, 0.4)",
              }}
            >
              <div
                className="card-body text-center"
                style={{ boxShadow: "none" }}
              >
                <div className="imgcontainer">
                  <img
                    alt=""
                    src="../images/iconManager.png"
                    style={{ height: "70px", width: "70px" }}
                    className="mb-2"
                  />
                </div>
                <h3
                  className="mb-3 lead"
                  style={{ color: "#ffffff", fontWeight: "bold" }}
                >
                  Racing Manager
                </h3>

                <div
                  className="input-group mb-4"
                  style={{ backgroundColor: "transparent" }}
                >
                  <i
                    className="fas fa-user-circle auth-icon mt-2 mr-2"
                    style={{ fontSize: "24px", color: "#ffffff" }}
                  ></i>
                  <input
                    type="text"
                    placeholder="Username"
                    id="userName"
                    name="userName"
                    onChange={handleChange}
                    value={form.userName}
                    className="form-control form-control-lg"
                  />
                </div>

                <div
                  className="input-group mb-4"
                  style={{ backgroundColor: "transparent" }}
                >
                  <i
                    className="fas fa-unlock fa-bold auth-icon mt-2 mr-2"
                    style={{ fontSize: "24px", color: "#ffffff" }}
                  ></i>
                  <input
                    type="Password"
                    placeholder="Password"
                    id="password"
                    name="password"
                    onChange={handleChange}
                    value={form.password}
                    className="form-control form-control-lg"
                  />
                </div>
                <button
                  type="submit"
                  id="login_Button"
                  className="btn btn-light btn-lg"
                  onClick={() => handleSubmit()}
                >
                  Login
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <PingDialog
        visible={dialogPingVisible}
        onHide={() => setDialogPingVisible(false)}
        pong={svcConnected}
        setDialogPingVisible={setDialogPingVisible}
      />
    </section>
  );
};

export default FormLogin;
